export const getParentPath = (planIndex: number, coverageIndex: number) =>
  `benefitPackagingDetail.plans[${planIndex}].coverageDefs[${coverageIndex}]`;

export const getHosAdmissionDetailsPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure.hosAdmissionDetails`;

  return {
    benefitAmount: `${parentPath}.benefitAmount.amount`,
    newbornInitialConfinementPct: `${parentPath}.newbornInitialConfinementPct`,
    firstDayConfinementPaymentFreqLimitCd: `${parentPath}.firstDayConfinementPaymentFreqLimitCd`,
    complicationsFromPregnancyCd: `${parentPath}.complicationsFromPregnancyCd`,
    normalPregnancyCd: `${parentPath}.normalPregnancyCd`,
  };
};

export const getHosConfinementDetailsPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure.hosConfinementDetails`;

  return {
    benefitAmount: `${parentPath}.benefitAmount.amount`,
    newbornConfinementPct: `${parentPath}.newbornConfinementPct`,
    maxBenefitNumber: `${parentPath}.maxBenefitNumber`,
  };
};

export const getIcuConfinementDetailsPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure.icuConfinementDetails`;
  return {
    benefitAmount: `${parentPath}.benefitAmount.amount`,
    newbornConfinementPct: `${parentPath}.newbornConfinementPct`,
    maxBenefitNumber: `${parentPath}.maxBenefitNumber`,
    icuConfinementDetails: parentPath,
    isICUConfinementApplied: `${getParentPath(planIndex, coverageIndex)}.benefitStructure.isICUConfinementApplied`,
  };
};
